
<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="incidentOwnersForm">
      <div class="">
        <h3 class="form_name">Incident Owners Mapping</h3>
  
  
          <div class="input">
            <label for="">Asset Location</label>
            <select class="default_input reference-form" formControlName="AssetLocationId" (change)="onSelectLocations($event.target.value)" #locatn style="width: 100%">
                <option value=""> Select Asset Location </option>
                    <option *ngFor="let locatn of assetLocations"  [value]="locatn.id">
                     {{locatn.AssetLocationAddress}}
                    </option>
            </select>
          </div>
         <div class="input">
            <label for="">Incident Owners</label>
            <select class="default_input reference-form" formControlName="StaffId" (change)="onSelectOwners($event.target.value)" #owner style="width: 100%">
                <option value=""> Select Incident Owners </option>
                    <option *ngFor="let owner of owners"  [value]="owner.id">
                     {{owner.StaffName}}
                    </option>
            </select>
              
          </div>
          
          
        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null" 
            (click)="addNew(incidentOwnersForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null" 
            (click)="addNew(incidentOwnersForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Incident Owners"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(incidentOwnersMappings | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectIncidentOwners(option.id)"
                  *ngFor="let option of result"
                  [value]="option.StaffName"
                >
                  {{ option.StaffName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Asset Location</span>
          <span class="item">Incident Owners</span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let incidentOwnersMapping of incidentOwnersFormArray.get('IncidentOwnerMappings')['controls']; index as i"
        (click)="onEdit(i, incidentOwnersMapping.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{getAssetLocationName(incidentOwnersMapping.value.AssetLocationId)}}</span>
           <span class="content">{{getStaffName(incidentOwnersMapping.value.StaffId)}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteIncidentOwnersMapping(i, incidentOwnersMapping.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(incidentOwnersFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  